import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import AuthProvider, { LoaderProvider } from "./Context/ContextFunctions";
import "./styles/custom.css"; // Import custom styles
import { useLocation, useNavigate } from "react-router-dom";
import { SocketProvider } from "./components/common/notificationSocket";
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <AuthProvider>
    {/* <SocketProvider> */}
    <App />
    {/* </SocketProvider> */}
  </AuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
